import { BarcodeScannerFormatKind } from '../types'

export const barcodeScannerFormatKinds: BarcodeScannerFormatKind[] = ['1D', 'QR']
